<template>
	<div class="progress" :class="`progress--${size}`">
		<div
			class="progress-bar"
			:class="`bg-${level}`"
			role="progressbar"
			:aria-valuenow="value"
			aria-valuemin="0"
			aria-valuemax="100"
			:style="{ width: `${value}%` }">
			<template v-if="showLabel">{{ value }}%</template>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ProgressBar',
	props: {
		value: {
			type: Number,
			default: 0,
		},
		size: {
			type: String,
			default: 'medium',
		},
		showLabel: {
			type: Boolean,
			default: false,
		},
		level: {
			type: String,
			default: 'primary',
		},
	},
};
</script>
